import { defineStore } from 'pinia'
import { useStorage } from '@vueuse/core'
import { ref, computed } from 'vue'
// import SecureLS from 'secure-ls'

// const ls = new SecureLS({ encodingType: 'aes', isCompression: false, encryptionSecret: 'vcy6u05eq7Vi+MKssWx+Ly0Tm5lHAwjmwXTHDnMU/bI=' })
// const ls = new SecureLS({ isCompression: false })

export const stores = defineStore('apprednat', () => {
  const colores = ref({})
  const rules = ref(null)
  const user = ref(null)
  const token = ref({ id: 0, text: '' })
  const apiUrl = ref('')
  const auth = ref(false)
  const expira = ref(null)
  const prefix = ref('')
  const theme = ref(1)
  const items = ref(null)
  const inbound = ref([])
  const mensajes = ref({ loading: false, data: { registros: [] } })

  const state = useStorage('rednat_store', { colores: colores.value, rules: rules.value, user: user.value, token: token.value, apiUrl: apiUrl.value, auth: auth.value, expira: expira.value, prefix: prefix.value, theme: theme.value, items: items.value, inbound: inbound.value, mensajes: mensajes.value })
  // getters
  const getColores = computed(() => state.value.colores)
  const getRules = computed(() => state.value.rules)
  const getUser = computed(() => {
    if (state.value.user != null) {
      return state.value.user
    } else {
      return null
    }
  })
  const getToken = computed(() => state.value.token)
  const getUrlApi = computed(() => state.value.apiUrl + 'api/')
  const getStorage = computed(() => state.value.apiUrl + 'storage/')

  const getAuth = computed(() => state.value.auth)
  const getExpira = computed(() => state.value.expira)
  const getPrefix = computed(() => {
    if (state.value.user != null) {
      return state.value.user.rol.prefix
    } else {
      return ''
    }
  })
  const getDark = computed(() => state.value.colores.isDark)
  const getTheme = computed(() => state.value.theme)
  const getItems = computed(() => state.value.items)
  const getInbound = computed(() => state.value.inbound)
  const getMensaje = computed(() => state.value.mensajes)

  const setColores = (pValue) => {
    state.value.colores = pValue
  }

  const setRules = (pValue) => {
    state.value.rules = pValue
  }

  const setUser = (pValue) => {
    state.value.user = pValue
  }

  const setToken = (pValue) => {
    state.value.token.id = pValue.accessToken.id
    state.value.token.text = pValue.plainTextToken
  }

  const setUrlApi = (pValue) => {
    state.value.apiUrl = pValue
  }

  const setAuth = (pValue) => {
    state.value.auth = pValue
  }

  const setExpira = (pValue) => {
    state.value.expira = pValue
  }

  const setPrefix = (pValue) => {
    state.value.prefix = pValue
  }

  const setTheme = (pValue) => {
    state.value.theme = pValue
  }

  const setInbound = (pValue) => {
    state.value.inbound = pValue
  }

  const setItems = (pValue) => {
    state.value.items = pValue
  }

  const setInboundDelete = () => {
    state.value.inbound = []
  }

  const setMensaje = (pValue) => {
    state.value.mensajes.data.pop(pValue)
  }

  return { user, theme, mensajes, colores, getColores, getRules, getUser, getToken, getUrlApi, getStorage, getAuth, getExpira, getPrefix, getDark, getTheme, getInbound, setColores, setRules, setAuth, setMensaje, getMensaje, getItems, setInbound, setItems, setInboundDelete, setExpira, setUser, setToken, setUrlApi, setPrefix, setTheme }
})
